const PreviewModal = ({ isOpen = false, onClose = () => {}, url = "" }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-[95vw] h-[90vh] relative overflow-hidden  p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 bg-black/70 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-black"
        >
          ✕
        </button>

        <iframe
          src={url}
          title="Blog Preview"
          className="w-full h-full border-0 rounded-xl"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default PreviewModal;
